import { leftOptions, selectClick } from '../helperFunctions'

const order = { arealtype: 1, treslag: 2, skogbonitet: 3, grunnforhold: 4 };

const filterOptions = (select, valid, overwrite, triggeringEvent) => {
  const id = select.id;
  const tid = triggeringEvent?.target?.id;
  const automaticallyChanged = triggeringEvent?.detail;
  // console.log(id, tid, automaticallyChanged);
  if (order[id] <= order[tid]) return; // triggering element only updates following lists
  const manualAction = (id === tid && !automaticallyChanged);
  // console.log(select.value, manualAction, valid);
  const forceUserToManuallySelect = (
    overwrite &&
    // (['', '39', '98', '99'].indexOf(select.value) > -1) &&
    !manualAction && valid.length > 1
  );
  if (forceUserToManuallySelect) select.value = ''; // «Velg...» will be visible
  for (let i = 0; i < select.length; i++) {
    const opt = select.options[i];
    // console.log(opt.value, opt.text);
    if (valid.indexOf(opt.value) < 0) { // non-valid option
      // console.log('non valid option, hide it');
      if (opt.value === select.value) { // what is stored is not valid
        // console.log('non valid option selected, it has to be changed');
        opt.title = 'Denne verdien gir ikke en lovlig kombinasjon i AR5';
        if (valid.length === 1 && select.value === '') select.value = valid[0];
        if (overwrite && valid.length > 0 && select.value !== '') {
          select.value = valid[0];
          // console.log('Trigger change to updated value on polygon');
          select.dispatchEvent(new CustomEvent('change', { detail: id })); // old
          select.dispatchEvent(new CustomEvent('input', { detail: id }));
          opt.hidden = true;
        } else { opt.disabled = true; }
      } else { opt.hidden = true; }
    } else {
      // console.log('keep it as a feasible option');
      opt.title = '';
      opt.hidden = false;
      opt.disabled = false;
    }
  }
};

export const justKeepFeasibleAr5Combinations = (overwrite, e) => {
  const arealtype = document.getElementById('arealtype').value;
  const ts = document.getElementById('treslag');
  filterOptions(ts, leftOptions(arealtype), overwrite, e);
  const treslag = ts.value;
  const sb = document.getElementById('skogbonitet');
  filterOptions(sb, leftOptions(arealtype, treslag), overwrite, e);
  const skogbonitet = sb.value;
  const gf = document.getElementById('grunnforhold');
  filterOptions(gf, leftOptions(arealtype, treslag, skogbonitet), overwrite, e);
};

// Mark as changed all four ar5-resources when multiple features are selected.
// This avoids that the last selection decides which resources to update.
export const changeAllAr5ResourcesWhenMultipleSelection = (changed) => {
  if (selectClick.getFeatures().getLength() < 2) return;
  ['arealtype', 'treslag', 'skogbonitet', 'grunnforhold'].forEach(resource => {
    if (!changed[resource]) {
      const newValue = document.getElementById(resource).value;
      changed[resource] = newValue;
      selectClick.getFeatures().getArray().forEach(
        feature => feature.set(resource, newValue)
      );
    }
  });
};
